// İhale alanlarını okunabilir metne çevirir (detay, PDF ve Excel ortak kullanır)
import {
  IHALE_DURUMLARI, IHALE_USULU_OPTIONS, ALIM_TURU_OPTIONS, SOZLESME_TURU_OPTIONS,
  IDARE_OPTIONS, ODENEK_DURUMU_OPTIONS, KESIN_KABUL_OPTIONS, KONTROL_EK_SECENEKLER, labelOf, toISODate,
} from './constants';
import { tesisTuruText } from '../../../utils/tesisTuru';

export const CODED_FIELDS = {
  ihale_usulu: IHALE_USULU_OPTIONS, alim_turu: ALIM_TURU_OPTIONS,
  sozlesme_turu: SOZLESME_TURU_OPTIONS, isi_yapan_idare: IDARE_OPTIONS, odenek_durumu: ODENEK_DURUMU_OPTIONS,
  durumu: IHALE_DURUMLARI, kesin_kabul_durumu: KESIN_KABUL_OPTIONS,
};
export const MONEY_FIELDS = ['yaklasik_maliyet', 'sozlesme_bedeli', 'is_artis_tutari_1', 'guncel_sozlesme_bedeli_1',
  'is_artis_tutari_2', 'guncel_sozlesme_bedeli_2', 'is_artis_tutari_3', 'guncel_sozlesme_bedeli_3',
  'toplam_odenen_hakedis', 'fiyat_farki_tutari', 'kesin_teminat_mektubu'];
export const VAR_YOK_FIELDS = ['is_artisi_1_var_mi', 'is_artisi_2_var_mi', 'is_artisi_3_var_mi', 'is_artisi_var_mi',
  'ek_kesin_teminat', 'revize_is_programi', 'ilave_all_risk', 'fiyat_farki'];
export const BOOL_FIELDS = ['insaat', 'elektrik', 'mekanik', 'ziraat'];
export const DATE_FIELDS = ['ihale_tarihi', 'sozlesme_tarihi', 'odenek_tarihi', 'yer_teslim_tarihi', 'bitis_tarihi',
  'sure_uzatimi', 'gecici_kabul_tarihi', 'kesin_kabul_tarihi'];
export const PERCENT_FIELDS = ['is_artis_orani_1', 'is_artis_orani_2', 'is_artis_orani_3', 'nakdi_ilerleme', 'fiziki_ilerleme'];

export const fmtDate = (d) => {
  if (!d) return '';
  const iso = toISODate(d);
  if (!iso) return String(d);
  const [y, m, day] = iso.split('-');
  return `${day}.${m}.${y}`;
};

export const varYok = (v) => (v === 'var' ? 'VAR' : v === 'yok' ? 'YOK' : '');

export const memurAdi = (id, users = []) => (id ? (users.find(u => u.id === id)?.name || id) : '');

export const kontrolAdi = (id, users = []) =>
  users.find(u => u.id === id)?.name || KONTROL_EK_SECENEKLER.find(s => s.id === id)?.name || id;

export const kontrolListesi = (ids, users = []) => (Array.isArray(ids) ? ids.map(id => kontrolAdi(id, users)) : []);

// Boş değer için '' döner; çağıran taraf gerekiyorsa '-' ile değiştirir
export function formatIhaleField(col, value, { users = [], displayMoney } = {}) {
  if (col === 'ilgilenen_memur') return memurAdi(value, users);
  if (col === 'tesis_turu') return tesisTuruText(value);
  if (col === 'kontrol_teskilati') return kontrolListesi(value, users).join(', ');
  if (BOOL_FIELDS.includes(col)) return value ? 'Evet' : 'Hayır';
  if (MONEY_FIELDS.includes(col)) return displayMoney ? displayMoney(value) : String(value || '');
  if (VAR_YOK_FIELDS.includes(col)) return varYok(value);
  if (CODED_FIELDS[col]) return labelOf(CODED_FIELDS[col], value);
  if (DATE_FIELDS.includes(col)) return fmtDate(value);
  if (PERCENT_FIELDS.includes(col)) return value ? `${value} %` : '';
  if (value === null || value === undefined || value === '') return '';
  return String(value);
}
